import styled from "@emotion/styled";

export const MidSectionContainer = styled.div`
  position: relative;
  width: 100%;
  background-color: #def0ff;
  padding: 20px 0;
  z-index: 1;
  margin-top: 150px; 

  @media (max-width: 1280px) {
    margin-top: 230px;
  }

  @media (max-width: 1024px) {
    margin-top: 80px;
  }

  @media (max-width: 780px) {
    margin-top: 50px;
  }

  @media (max-width: 480px) {
    margin-top: 30px;
  }
`;



// /* Medium screens: 780px – 1023px */
// @media (max-width: 1023px) {
//   margin-top: 140px;
// }

// /* Small screens: 480px – 779px */
// @media (max-width: 779px) {
//   margin-top: 160px;
// }

// /* Extra small screens: below 480px */
// @media (max-width: 479px) {
//   margin-top: 180px;
// }